import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';
import { addBusinessDays, DateInput } from 'src/app/shared/utils/dates';

@Injectable({
    providedIn: 'root'
})
export class UtilsService {

    constructor() { }

    public static async clipboardCopy(text: string) {
        await navigator.clipboard.writeText(text);
    }

    public static async clipboardPaste(): Promise<string> {
        return await navigator.clipboard.readText();
    }

    public static async sleep(ms: number) {
        return new Promise((resolve) => {
            setTimeout(resolve, ms);
        });
    }

    public static addBusinessDays(originalDate: DateInput, numDaysToAdd: number): Date {
        return addBusinessDays(originalDate, numDaysToAdd);
    }
}
